import axiosPost from '../axiosPost';

export const conciliacionesConciliar = async (arg) => {
    const { operaciones } = arg

    const body = {
        "service": "BindConciliacionConciliar",
        "params": {
            "bindConciliacionOperaciones": operaciones
        }
    };

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    }
    catch (err) {
        console.log(err)
    };
};